import { generatePath } from 'react-router-dom'
import { ADVERTISEMENT, MOVIE, HIGHLIGHT, WEISCHER, IMAGE, TEXT, TITLE, MOVIE_PERFORMANCES, GRID_IMAGE, METRO, NEWSLETTER_IMAGE, NEWSLETTER_TEXT, CUSTOMITEMS } from '../../../constants/itemTypes'
import EditMovieContainer from '../cont/EditMovieContainer'
import EditAdContainer from '../cont/EditAdContainer'
import EditHighlightContainer from '../cont/EditHighlightContainer'
import EditWeischerAdContainer from '../cont/EditWeischerAdContainer'
import EditElementContainer from '../cont/EditElementContainer'
import EditAdvertisementsContainer from '../cont/EditAdvertisementsContainer'
import EditNewsletterElementContainer from '../cont/EditNewsletterElementContainer'
import { FLYER, NEWSPAPER } from '../../../constants/printType'
import EditFlyerContainer from '../cont/EditFlyerContainer'
import EditNewspaperContainer from '../cont/EditNewspaperContainer'
import EditCustomItemsContainer from '../cont/EditCustomItemsContainer'

const EditItem = ({goBackPath, match, updateRemote=false}) => {
    const { itemId, itemType, printType, campaignId, cinemaId, printPk } = match.params

    const closePagePath = generatePath(goBackPath, match.params)
    const suffixEdit = match.path.endsWith('/edit-item') ? '/edit-item' : ''

    if(FLYER === itemType) {
        return <EditFlyerContainer
            itemId={itemId} 
            closePagePath={closePagePath}
        />
    } else if(MOVIE === itemType) {
        return <EditMovieContainer 
            itemId={itemId} 
            closePagePath={closePagePath}
            updateRemote={updateRemote}
        />
    } else if(NEWSPAPER === itemType) {
        return <EditNewspaperContainer
            itemType={itemType} 
            closePagePath={closePagePath}
        />
    } else if(HIGHLIGHT === itemType) {
        return <EditHighlightContainer
            itemId={itemId}
            suffixEdit={suffixEdit}
            closePagePath={closePagePath}
        />
    } else if(WEISCHER === itemType) {
        return <EditWeischerAdContainer
            itemId={itemId}
            closePagePath={closePagePath}
        />
    } else if((IMAGE === itemType && printType) || (TEXT === itemType && printType) || TITLE === itemType || MOVIE_PERFORMANCES === itemType || GRID_IMAGE === itemType ||  METRO === itemType) {
        return <EditElementContainer
            itemId={itemId}
            closePagePath={closePagePath}
            printPk={printPk}
            itemType={itemType}
        />
    } else if((NEWSLETTER_TEXT === itemType && campaignId) || (NEWSLETTER_IMAGE === itemType && campaignId)) {
        return <EditNewsletterElementContainer
            itemId={itemId}
            itemType={itemType}
            closePagePath={closePagePath}
        />
    } else if(ADVERTISEMENT === itemType)  {
        return <EditAdvertisementsContainer
            itemId={itemId}
            closePagePath={closePagePath}
        />
    } else if(CUSTOMITEMS === itemType)  {
        return <EditCustomItemsContainer
            itemId={itemId}
            cinemaId={cinemaId}
            closePagePath={closePagePath}
        />
    } else {
        return <EditAdContainer 
            itemId={itemId}
            suffixEdit={suffixEdit}
            closePagePath={closePagePath}
        />
        
    }
}

export default EditItem